// Types
type IconProps = {
  size?: number;
  className?: string;
};

/**
 * Archie "A." logo icon
 */
export const ALogoIcon = ({ size = 32, className }: IconProps) => (
  <svg
    width={size}
    height={(size * 26) / 32}
    viewBox="0 0 32 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <g clipPath="url(#alogo_clip0)">
      <path
        d="M10.8912 17.3949L10.4796 17.8462H9.55762V18.329H13.3213V17.8462H11.8859L11.5959 17.5282L12.3702 15.5016H16.5413L17.272 17.5209L16.9758 17.8462H15.5955V18.329H20.2862V17.8462H19.5368L19.2479 17.5293L15.2722 7.50732H13.3337L13.421 7.77495L14.0946 9.41642M11.4815 17.8462H11.4753L11.5304 17.7014L11.4815 17.8462ZM15.9021 14.7932H13.0178L12.7704 14.5224L14.3212 10.7231H14.6236L15.1818 12.119L15.8896 13.8895L16.1453 14.5287L15.9031 14.7942L15.9021 14.7932ZM16.1796 14.5969H16.1806L16.2607 14.7942L16.1796 14.5969Z"
        fill="currentColor"
      />
      <path
        d="M21.7785 18.3291C22.1281 18.3291 22.4115 18.0429 22.4115 17.6899C22.4115 17.3369 22.1281 17.0508 21.7785 17.0508C21.4289 17.0508 21.1455 17.3369 21.1455 17.6899C21.1455 18.0429 21.4289 18.3291 21.7785 18.3291Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="alogo_clip0">
        <rect
          width="14.0627"
          height="14.0627"
          fill="white"
          transform="translate(8.95312 5.85938)"
        />
      </clipPath>
    </defs>
  </svg>
);
